/* eslint-disable max-len */
export default [
  {
    title: 'Pricing \n Benefits',
    ctaUrl: '/a/pricing-benefits',
    imageUrl: 'https://dam.thdstatic.com/content/production/2jC8BFJ3aaE-FDgVkpnHEg/hWpCm69JK2Wuc9-yJZNBgw/Original%20file/pro-business-icon-128-px--pro-xtra-preferred-pricing-v1.svg'
  },
  {
    title: 'Bulk \n Pricing',
    ctaUrl: '/c/bulk_pricing',
    imageUrl: 'https://dam.thdstatic.com/content/production/pCyjp4owpqOIil_AW75b0w/W-m7wKsJvLOCEX9eDBsifg/Original%20file/pro-business-icon-128-px--add-predefined-job-names-v1.svg'
  },
  {
    title: 'Shop By \n Job',
    ctaUrl: '/c/shop-by-job',
    imageUrl: 'https://dam.thdstatic.com/content/production/T32T_wui11EMLcmIBBywGw/DPUU_48UxpjXmH6ZG7BbaA/128*128%20size/BS_ProXtra_BusinessTools_RGB_OrangeBlack_128128%20size.jpg'
  },
  {
    title: 'Paint Services \n & Rewards',
    ctaUrl: '/c/pro-paint-services-and-rewards',
    imageUrl: 'https://dam.thdstatic.com/content/production/ti0ncziGJXiAQH3AVpoJFA/qaL_ZZYuJxmI2DNIDWWm3g/Original%20file/pro-business-icon-128-px--pro-xtra-paint-rewards-v1.svg'
  },
  {
    title: 'Fast Supply \n & Pick Up',
    ctaUrl: '/c/get-it-fast',
    imageUrl: 'https://dam.thdstatic.com/content/production/NStGOoKBJ0v-kVYR4hwyrA/bKLKNU8ix-TpGImKJvV8lg/Original%20file/pro-business-icon-128-px--easy-delivery-management-v1.svg'
  },
  {
    title: 'Tax Exempt \n Purchases',
    ctaUrl: '/c/tax-exempt-purchases-for-pros',
    imageUrl: 'https://dam.thdstatic.com/content/production/wRBl672XtZd0KeQZRfUKaQ/iOy9rzTI_60Q6WGH43nkLA/Original%20file/pro-business-icon-128-px--tax-exempt-purchases-v1.svg'
  }
]